// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_onexpense_src_app_documentation_documentation_module_ts":"5a6c1f0ab443755f","projects_onexpense_src_app_invitation_invitation_module_ts":"926cbfdafbba8186","projects_onexpense_src_app_dashboard_dashboard_module_ts":"5fcfb48a70e6191f"}[chunkId] + ".js";
};